import {add, set} from "date-fns";

import {CountryCode} from "~/constants/countryCode";

/* regexps */
export const EMAIL_REGEXP = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
export const LETTERS_NUMBERS_REGEXP = /^[a-zA-Z0-9]+$/;
// taken from https://stackoverflow.com/questions/3452546/how-do-i-get-the-youtube-video-id-from-a-url
export const YOUTUBE_VIDEO_REGEXP = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
//taken from https://stackoverflow.com/questions/5008609/vimeo-video-link-regex
export const VIMEO_VIDEO_REGEXP =
  /^https?:\/\/(www\.|player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)/;
//taken from https://stackoverflow.com/questions/5612602/improving-regex-for-parsing-youtube-vimeo-urls
export const YOUTUBE_AND_VIMEO_REGEXP =
  /^https?:\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\S+)?/;
// taken from https://uibakery.io/regex-library/url
export const URL_REGEXP =
  /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_.~#?&/=]*)$/;
// SWIFT/BIC: 8 or 11 chars, uppercase, no spaces; chars 1-6 letters (4 bank + 2 country), 7-8 alphanumeric, optional 3-char branch. Rejects 9/10-char values.
export const SWIFT_REGEXP = /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/;

// VAT number format per supported country, used to skip the backend VIES call
export const VAT_FORMAT_BY_COUNTRY: Partial<Record<CountryCode, RegExp>> = {
  [CountryCode.AT]: /^ATU\d{8}$/,
  [CountryCode.DE]: /^DE\d{9}$/,
  [CountryCode.DK]: /^DK\d{8}$/,
  [CountryCode.FR]: /^FR[A-Z0-9]{2}\d{9}$/,
  [CountryCode.NL]: /^NL\d{9}B\d{2}$/,
  [CountryCode.SE]: /^SE\d{10}01$/,
  [CountryCode.ES]: /^ES[A-Z0-9]\d{7}[A-Z0-9]$/,
  [CountryCode.NO]: /^NO\d{9}(MVA)?$/,
  [CountryCode.CH]: /^CHE\d{9}(MWST|TVA|IVA)?$/,
};

// TRANSITION ms
export const TRANSITION_TIME = 350;

// TOAST TRANSITION
export const TOAST_TRANSITION = 3000;

// DEFAULT PACKAGING WEIGHT
export const DEFAULT_PACKAGING_WEIGHT = 0.5;

export const REQUEST_ACCESS_LINK = "https://share-eu1.hsforms.com/1eOWAMuGIQF6e0zoAVtBK4Qf8gr6";
export const GOOGLE_MAPS_BASE_LINK = "https://maps.google.com/?q=";
export const BEMAKERS_LINK = "https://bemakers.com/";
export const BEMAKERS_HELP_CENTER_LINK = "https://support.bemakers.com/hc/en-us";
export const WATS_NEW_URL = "https://support.bemakers.com/hc/en-us/categories/5613711201949-Bemakers-Update";
export const GDPR_LINK = "https://gdpr.eu/what-is-gdpr/";
export const SEED_LINK =
  "https://ec.europa.eu/taxation_customs/dds2/seed/seed_consultation.jsp?Lang=en&Expand=true&offset=1&Excnr=SK52002100023";
export const VIES_LINK = "https://ec.europa.eu/taxation_customs/vies/";
export const EXCISE_DUTY_CALCULATOR_LINK = "https://bemakers.com/excise-duty-calculator";
export const BEMAKERS_PRICING_LINK = "https://bemakers.com/pricing";
export const BEMAKERS_CN_CODE = "https://support.bemakers.com/hc/en-us/articles/5915717805981-What-is-a-CN-Code";

export const TOMORROW = add(new Date(), {
  days: 1,
});
export const TODAY_MIDNIGHT = set(new Date(), {
  hours: 0,
  minutes: 0,
  seconds: 0,
  milliseconds: 0,
});
export const TOMORROW_MIDNIGHT = add(TODAY_MIDNIGHT, {days: 1});
export const AFTER_TOMORROW_MIDNIGHT = add(TOMORROW_MIDNIGHT, {days: 1});
export const INVENTORY_SNAPSHOT_LAST_DATE = new Date(2025, 1, 1);
export const BEMAKERS_INIT_DATE = new Date(2021, 0, 0);

export const ALL_PACKAGING_CODES = ["BO", "BQ", "BW", "CX", "CT", "CW", "KG", "PO", "PB", "PP"];
export const SUPPORT_EMAIL = "support@bemakers.com";

export const TRADE_USERS = "__TRADE_USERS";
export const CURRENT_USER = "__CURRENT_USER";
